export default "__VITE_ASSET__CfMUC0hF__"